import axios from 'axios';

import {
  SET_ALERT_OPEN,
  SET_MOB_SIDE_NAV_BAR_VISIBILITY,
  SET_FILTERS_VISIBILITY,
  SET_THEME,
} from './types';

const THEME_STORAGE_KEY = 'app-theme';

export const setTheme = (mode) => (dispatch) => {
  const value = mode === 'dark' ? 'dark' : 'light';
  try {
    localStorage.setItem(THEME_STORAGE_KEY, value);
  } catch (e) {}
  dispatch({ type: SET_THEME, payload: value });
};

export const getStoredTheme = () => {
  try {
    const saved = localStorage.getItem(THEME_STORAGE_KEY);
    if (saved === 'dark' || saved === 'light') return saved;
  } catch (e) {}
  return 'light';
};

export const showAlert = (props) => async (dispatch) => {
  dispatch({
    type: SET_ALERT_OPEN,
    payload: props,
  });
};

export const setMobSideNavBarVisibility =
  (current_visibility) => async (dispatch) => {
    dispatch({
      type: SET_MOB_SIDE_NAV_BAR_VISIBILITY,
      payload: !current_visibility,
    });
  };

export const setFiltersVisibility = (visibility) => async (dispatch) => {
  console.log('current_visibility', visibility);
  dispatch({
    type: SET_FILTERS_VISIBILITY,
    payload: visibility,
  });
};
